import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

// Components
import GeneralHospital from "./QuickLinks/GeneralHospital/GeneralHospital";
import Ugc from "./QuickLinks/Ugc/Ugc";
import DynamicPages from "./DynamicPages/DynamicPages";
import Contact from "./Pages/Contact/Contact";
import CourseIntergrate from './QuickLinks/CourseIntergrate/CourseIntergrate';

const RouteResolver = () => {
  const { slug } = useParams();

  const [type, setType] = useState(null);

  useEffect(() => {
    const checkRoute = async () => {
      try {
        const hospitalRes = await api.get(
          `/api/hospital/check-slug/${slug}`
        );

        if (hospitalRes.data.exists) {
          setType("hospital");
          return;
        }

        const ugcRes = await api.get(
          `/api/check-ugc-slug/${slug}`
        );

        if (ugcRes.data.exists) {
          setType("ugc");
          return;
        }

        const contactRes = await api.get(
          `/api/check-contact-slug/${slug}`
        );

        if (contactRes.data.exists) {
          setType("contact");
          return;
        }

        const courseIntegrateRes = await api.get(
          `/api/check-course-integrate-slug/${slug}`
        );

        if (courseIntegrateRes.data.exists) {
          setType("course-integrate");
          return;
        }

        setType("dynamic");

      } catch (error) {
        console.error("Route resolve error:", error);

        setType("dynamic");
      }
    };

    checkRoute();
  }, [slug]);

  if (!type) {
    return null;
  }

  if (type === "hospital") {
    return <GeneralHospital />;
  }

  if (type === "ugc") {
    return <Ugc />;
  }

  if (type === 'contact') {
    return <Contact />
  }

  if (type === "course-integrate") {
    return <CourseIntergrate />;
  }

  return <DynamicPages />;
};

export default RouteResolver;